import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { applyResize } from '../../tableCore/columns/columnsState';
export function useColumnInteractions(param) {
    let { columns, columnsState, onColumnsStateChange } = param;
    const [resize, setResize] = useState();
    const onResizeStart = useCallback((columnId, event)=>{
        const column = columns.find((candidate)=>candidate.id === columnId);
        if (column == null) return;
        // WHY: the table stops distributing spare width once a column is resized, so the widths
        // it had just rendered are pinned first — otherwise every other column would snap back
        // to its declared width the moment the drag begins. The drag then builds on this
        // snapshot rather than on the state prop, which the first mouse move can still read
        // from before this update has been committed.
        const pinned = _object_spread_props(_object_spread({}, columnsState), {
            widths: Object.fromEntries(columns.map((candidate)=>{
                var _columnsState_widths_candidate_id;
                return [
                    candidate.id,
                    (_columnsState_widths_candidate_id = columnsState.widths[candidate.id]) !== null && _columnsState_widths_candidate_id !== void 0 ? _columnsState_widths_candidate_id : candidate.width
                ];
            }))
        });
        onColumnsStateChange === null || onColumnsStateChange === void 0 ? void 0 : onColumnsStateChange(pinned);
        setResize({
            columnId,
            startX: event.clientX,
            startWidth: column.width,
            minWidth: column.minWidth,
            pinned
        });
    }, [
        columns,
        columnsState,
        onColumnsStateChange
    ]);
    useEffect(()=>{
        if (resize == null) return;
        const handleMove = (event)=>{
            const width = resize.startWidth + (event.clientX - resize.startX);
            onColumnsStateChange === null || onColumnsStateChange === void 0 ? void 0 : onColumnsStateChange(applyResize({
                state: resize.pinned,
                columnId: resize.columnId,
                width,
                minWidth: resize.minWidth
            }));
        };
        const handleUp = ()=>setResize(undefined);
        window.addEventListener('mousemove', handleMove);
        window.addEventListener('mouseup', handleUp);
        return ()=>{
            window.removeEventListener('mousemove', handleMove);
            window.removeEventListener('mouseup', handleUp);
        };
    }, [
        resize,
        onColumnsStateChange
    ]);
    return useMemo(()=>({
            onResizeStart
        }), [
        onResizeStart
    ]);
}
